import {observable, action, runInAction} from 'mobx'
import {json, get} from '../../../../utils/ajax'
import {handleSearchAndPage, setStore, ValueObjToObj,objToValueObj,searchs} from "../../../../utils/Utils";
import {message} from "antd/lib/index";
import moment from "moment/moment";

class masterSparepartStore {
    @observable loading //主列表列表
    @observable list //主列表
    @observable pagination //主列表分页
    @observable viewOrderVisible  //查看订单显示属性
    @observable viewOrderTitle  //查看订单标题显示
    @observable exportModal  //采购状态维护显示
    @observable attributeEditVisible  //属性维护显示属性
    @observable exportModalTitle  //采购状态维护/标准名称维护模态框标题
    @observable exportModalUrl  //采购状态维护/标准名称维护模态框上传路径
    @observable timeModalVisible //显示时间段属性
    @observable otherExportModal //多种导出模态框显示
    @observable carSeriesVisible //车系配置模态框显示
    @observable timeX //获取时间框坐标X
    @observable timeY //获取时间框坐标Y
    @observable carSeriesStatus //车系选中状态
    @observable otherExportField //多种导出表单绑值
    @observable vinExportFlag //多种导出控制VIN下载是否显示
    @observable carlCodeExportFlag //多种导出控制整车物料号下载是否显示
    @observable selectCarSeriesValue //车系配置模态框显示当前选中value，展示卡片title
    @observable addFields //新增、修改表单值绑定
    @observable searchFields //主页面搜索表单值绑定
    @observable rowDeleteId //保存删除ID
    @observable timeChangeList //时间段
    @observable viewOrderFields //查看订单表单值
    @observable viewOrderList //查看订单列表数据
    @observable materialCode //保存查看订单订单号
    @observable piece  //件类
    @observable supplierStatus   //供货状态
    @observable createType     //新增类型
    @observable manufacturingResource      //制造资源
    @observable developmentPeriod      //开发周期
    @observable attributeId      //属性维护id
    @observable isFormMes      //判断是否来自MES
    @observable viewOrderLoading      //查看订单loading
    @observable confirmLoading      //新增及修改确认Loading
    @observable isHaveCarseries      //判断车型描述是否存在
    @observable carList      //导出车系
    @observable carSeriesExportField      //车型配置导出表单绑值
    @observable carSeriesField      //获取车系配置数据
    @observable carseriesCode
    @observable selectedRowKeys //多选选中数据
    @observable rowSelectionCheck//保存勾选数据
    @observable fileName//上传框表单绑定
    @observable modelStatus
    @observable showDrawer
    @observable importReturnData
    @observable addModalTitle  //模态框名字
    @observable addModal  //模态框
    @observable editExportModal  //采购状态维护模态框
    @observable ExportModal  //导入模态框
    @observable ViewOrderModal   //查看订单模态框
    @observable disabledExport//导出限制
    @observable searchInstantiation //搜索实例化

    constructor() {
        this.loading = false

        this.list = []
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {
            }
        }
        this.carseriesCode=''
        this.carseriesCodes = []
        this.viewOrderVisible = false
        this.viewOrderTitle = ''
        this.exportModal = false
        this.attributeEditVisible = false
        this.exportModalTitle = ''
        this.exportModalUrl = ''
        this.timeModalVisible = false
        this.otherExportModal = false
        this.carSeriesVisible = false
        this.timeX = ''
        this.timeY = ''
        this.carSeriesStatus = false
        this.otherExportField = {
            vin: '',
            carSeries: '',
            carMaterialCode: ''
        }
        this.vinExportFlag = false
        this.carlCodeExportFlag = false
        this.selectCarSeriesValue = ''
        this.searchFields = {
            materialCode: '',
            partCode: '',
            partName: '',
            isDefinition: '',
            isMes: '',
            isProcurement: ''
        }
        this.addFields = {
            materialCode: '',  //物料号
            partCode: '',  //零件号
            partName: '',  //零件名称
            partEnName: '',  //零件英文名
            loadPart: '',  //装车件标识
            timing: '',   //时间段
            partType: '',   //件类
            unitWeight: '',  //单件重量
            thickness: '',   //厚度
            materialsMark: '',   //材料记号
            manufacturingResource: '',  //制造资源
            type: '',  //类型
            firstCar: '',  //首用车型
            isColor: '',  //是否为颜色件
            isAroud: '', //是否为左右件
            isProcurement: '',  //是否能采购
            isPlatform: '',  //是否为平台件
            isAappearance: '',  //是否为外观件
            isForceTest: '',  //是否为强检件
            is3C: '',  //是否为3c件
            isEnvironmentalProtection: '',  //是否涉及voc及环保要求
            isPerpetualMark: '',  //永久性标识
            importanceDegree: '',  //重要度分级
            designer: '',  //设计者
            supplierName: '',  //供应商名称
            supplierStatus: '',  // 供货状态
            developmentPeriod: '',  //开发周期
            specifications: '',  //规格
            performanceRate: '',  //性能等级
            surfaceTreatment: '',  //表面处理
            moment: '',  //力矩
            mountingPlaces: '',  //紧固部位
            isGauge: '',  //检具
            gaugeDrawing: '',  //检具图纸
            amount: '',//数量
            createType: '',  //新增类型
            dealStatus: '',  //处理状态
            salesDescription: '',  //销售描述
            developDescription: '',  //研发描述
            effectiveNo:'',//ASR生效单
            lapseNo:'',//ASR失效单
            incorporationDate:null,//编入日期
            expirationDate:null,//失效日期
        }
        this.rowDeleteId = ''
        this.timeChangeList = []
        this.viewOrderFields = {
            carMaterialCode: '',
            orderNo: '',
            carseriesCode:''
        }
        this.viewOrderList = []
        this.materialCode = ''
        this.piece = []  //件类
        this.supplierStatus = []   //供货状态
        this.createType = []     //新增类型
        this.manufacturingResource = []      //制造资源
        this.developmentPeriod = []     //开发周期
        this.attributeId = ''
        this.isFormMes = ''
        this.viewOrderLoading = false
        this.confirmLoading = false
        this.isHaveCarseries = false
        this.carList=[]
        this.carSeriesExportField={
            carYear: '',
            displacement: '',
            emissionNormal: '',
            driveModel: '',
            configName: '',
            transmission: '',
            carseriesCode:''
        }
        this.carSeriesField={
            carYear: [],
            displacement: [],
            emissionNormal: [],
            driveModel: [],
            configName: [],
            transmission: [],
        }

        this.selectedRowKeys=[]
        this.rowSelectionCheck=[]
        this.fileName=''
        this.modelStatus=false
        this.showDrawer = false
        this.importReturnData=[]
        this.addModalTitle = ''
        this.addModal = false
        this.editExportModal = false
        this.ExportModal = false
        this.ViewOrderModal = false
        this.disabledExport = ''
        this.searchInstantiation = ''
    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    /***表单绑值**/
    @action
    onFormField = (changedFields, fields) => {
        const change = ValueObjToObj(changedFields)
        this[fields] = {...this[fields], ...change}
    }

    /***新增维护表单绑值，不进行转换**/
    @action
    onAddFieldsForm = (changedFields, fields) => {
        this[fields] = {...this[fields], ...changedFields}
    }

    /*******************************主页面********************************************************/
    /**
     * //进主页面请求接口加载数据
     * @param page
     * @returns {Promise<void>}
     */
    @action
    initPage = async (page) => {
        this.loading = true
        this.searchFields = {
            ...this.searchFields,
            isMes: this.searchFields.isMes ? this.searchFields.isMes : '',
            isProcurement: this.searchFields.isProcurement ? this.searchFields.isProcurement : ''
        }
        let search = handleSearchAndPage(page, this.pagination, this.searchFields)
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/master/sparepart:search`, search)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.list = res.content ? res.content : []
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共 ${res.totalElements} 条`
            }
            this.loading = false
        })
    }

    /***清空主页面搜索表单值，重置***/
    @action
    clearForm = () => {
        this.searchFields = {
            materialCode: '',
            partCode: '',
            partName: '',
            isDefinition: '',
            isMes: '',
            isProcurement: ''
        }
        this.selectedRowKeys=[]
        this.rowSelectionCheck=[]
        this.disabledExport = 0
        this.initPage()
    }

    /**显示查看订单模态***/
    @action
    viewOrder = async (record) => {
        this.materialCode = record.materialCode
        this.viewOrderTitle = `${record.materialCode}${record.supplierName ? '-- ' : ''}${record.supplierName ? record.supplierName : ''}`;
        this.viewOrderVisible = true
        this.initOrderPage()
    }

    /**查看订单列表**/
    @action
    initOrderPage = async () => {
        this.viewOrderLoading = true
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/mes/by_materialcode`,{
            carMaterialCode: this.materialCode,
            materialCode: this.searchInstantiation
        })
        if (res && res.status === 0) {
            runInAction(() => {
                this.viewOrderLoading = false
            })
            return
        }
        runInAction(() => {
            this.viewOrderList = res ? res : []
            this.viewOrderLoading = false
        })
    }

    /***删除***/
    @action
    delete = async () => {
        this.loading = true
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/master/sparepart/delete/all`,this.selectedRowKeys)
        runInAction(() => {
            message.success('删除成功')
            this.loading = false
            this.selectedRowKeys = []
            this.rowSelectionCheck=[]
        })
        this.initPage()
    }

    /*******************************多种导出********************************************************/
    /**关闭导出框时清空数据***/
    @action
    clearOtherExport = () => {
        this.carSeriesStatus = false
        this.otherExportField = {
            vin: '',
            carSeries: '',
            carMaterialCode: ''
        }
        this.vinExportFlag = false
        this.carlCodeExportFlag = false
    }


    /****获取车系***/
    @action
    initCarseries = async () => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carBasicData/carBaseCarSeries/get/object/carsystem`)
        runInAction(() => {
            this.carList = Array.isArray(res) ? res : ''
        })
    }

    /**检查VIN是否存在**/
    @action
    findVin = async () => {
        if (!this.otherExportField.vin) {
            message.warning('请输入VIN')
        } else {
            this.loading = true
            const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/mes/export/is_exist_vin/${this.otherExportField.vin}`)
            if (res === false) {
                message.error("该VIN码不存在")
                runInAction(() => {
                    this.vinExportFlag = false
                    this.loading = false
                })
            } else {
                runInAction(() => {
                    this.vinExportFlag = true
                    this.loading = false
                })
            }
        }
    }

    /**检查物料号是否存在**/
    @action
    findMaterialCode = async () => {
        if (!this.otherExportField.carMaterialCode) {
            message.warning('请输入整车物料号')
        } else {
            this.loading = true
            const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/mes/export/is_exist_carmaterialcode/${this.otherExportField.carMaterialCode}`)
            if (res === false) {
                message.error("该物料号不存在")
                runInAction(() => {
                    this.carlCodeExportFlag = false
                    this.loading = false
                })
            } else {
                runInAction(() => {
                    this.carlCodeExportFlag = true
                    this.loading = false
                })
            }
        }
    }


    /****获取车型配置***/
    @action
    getCarSeries=async()=>{
        let seacrhFild={
            carseriesCode:this.selectCarSeriesValue
        }
        this.carSeriesExportField={
            carYear: '',
            displacement: '',
            emissionNormal: '',
            driveModel: '',
            configName: '',
            transmission: '',
            carseriesCode:this.selectCarSeriesValue
        }
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carseriesconfiguration/queryAllConfigByCondition`,searchs(seacrhFild))
        runInAction(()=>{
            this.carSeriesField={
                carYear: res.carYear|| [],
                displacement: res.displacement||[],
                emissionNormal: res.emissionNormal||[],
                driveModel:res.driveModel|| [],
                configName: res.configName||[],
                transmission: res.transmission||[],
            }
        })
    }

    /*******************************新增、维护属性********************************************************/
    /****验证车系描述名称是否存在***/
    @action
    checkCarseries = async (value) => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carBasicData/carBaseCarSeries/get/cars/name`)
        runInAction(() => {
            let isHaveCarseries = ''
            res && res.find(item => { // eslint-disable-line
                if (item === value) {
                    isHaveCarseries = true
                }
            })
            if (!isHaveCarseries) {
                message.warning('请填写正确的使用车型描述')
                this.isHaveCarseries = false
            } else {
                this.isHaveCarseries = true
            }
        })
    }

    /**验证物料编号是否正确***/
    @action
    checkMaterialCode=async(rule, value, callback)=>{
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/master/sparepart/verify/${value}`)
        if(res.id){
            runInAction(()=>{
                this.addFields={
                    ...this.addFields
                }
            })
            callback("东风零件号不能重复")
        }
        callback()
    }

    /**显示新增、维护框**/
    @action
    showAttributeModal = async (record) => {
        this.loading = true
        this.attributeId =''
        if (record) {
            this.isHaveCarseries=true
            this.attributeId = record.id
            this.isFormMes = record.isMes
            let search = {}
            search['id'] = record.id
            const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/master/sparepart`, search)
            runInAction(() => {
                this.addFields ={
                    ...objToValueObj(res),
                    incorporationDate:{value:res.incorporationDate ? moment(res.incorporationDate) : null},
                    expirationDate:{value:res.expirationDate ? moment(res.expirationDate) : null},
                }
            })
        }else{
            this.addFields={}
        }
        runInAction(() => {
                this.attributeEditVisible = true
                this.loading = false
            }
        )
    }

    /**关闭新增、维护框**/
    @action
    cancelAttributeEditModal = () => {
        this.attributeEditVisible = false
        this.addModal = false
        const clearAddFields = {}
        Object.keys(this.addFields).forEach(key => {
            clearAddFields[key] =''
        })
        this.addFields=clearAddFields
        this.attributeId = ''
        this.isFormMes = ''
        this.isHaveCarseries = false
        this.modelStatus= true
    }

    /**新增及修改**/
    @action
    saveAddOrEdit = async () => {
        this.confirmLoading = true
        let addFields = {
            ...ValueObjToObj(this.addFields),
            incorporationDate:ValueObjToObj(this.addFields).incorporationDate ? moment(ValueObjToObj(this.addFields).incorporationDate).format("YYYY-MM-DD") : null,
            expirationDate:ValueObjToObj(this.addFields).expirationDate ? moment(ValueObjToObj(this.addFields).expirationDate).format("YYYY-MM-DD") : null,
        }
        if (this.attributeId) {
            addFields.id=this.attributeId
            const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/master/sparepart/add`, addFields)
            if (res.status === 1) {
                message.success('修改成功')
            }else {
                message.error('修改失败')
            }
            runInAction(() => {
                this.confirmLoading = false

            })
            this.cancelAttributeEditModal()
            this.initPage(this.pagination.current)
        } else {
            const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/master/sparepart/add`, addFields)
            if(res.status === 1){
                message.success("新增成功")
            }else{
                message.success('新增失败')
                runInAction(() => {
                    this.modelStatus= true
                })
            }
            this.cancelAttributeEditModal()
            runInAction(() => {
                this.confirmLoading = false
            })
            this.cancelAttributeEditModal()
            this.initPage(this.pagination.current)
        }
    }

    /**件类 供货状态 新增类型  制造资源 开发周期**/
    @action
    others = async () => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/master/findByDictory`)
        runInAction(() => {
            this.piece = res.data ? res.data.piece.children : []   //件类
            this.supplierStatus = res.data ? res.data.supplierStatus.children : []//供货状态
            this.createType = res.data ? res.data.createType.children : [] //新增类型
            this.manufacturingResource = res.data ? res.data.manufacturingResource.children : []  //制造资源
            this.developmentPeriod = res.data ? res.data.developmentPeriod.children : [] //开发周期
        })
    }

    /*******************************时间段********************************************************/
    /**新增行**/
    @action
    addTimeChangeList = () => {
        this.timeChangeList.push(' ')
    }
    /**删除行**/
    @action
    removeTimeChangeList = (index) => {
        this.timeChangeList.splice(index, 1)
    }

    /**将勾选数据保存至EPC,***/
    @action
    saveSelectedRowKeys=(selectedRowKeys,selectedRows)=>{
        this.rowSelectionCheck = selectedRows ? selectedRows :[]
        this.selectedRowKeys = selectedRowKeys
    }

    @action
    initCarService = async () => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carBasicData/carBaseCarSeries/get/object/carsystem`)
        runInAction(() => {
            this.carseriesCodes = Array.isArray(res) ? res : []
        })
    }


    @action
    onUpload=(arr)=>{
        this.importReturnData = arr
        this.showDrawer=true
    }

    /***
     * 关闭抽屉
     */
    @action
    onClose=()=>{
        this.showDrawer=false
    }

}


export default new masterSparepartStore()



// WEBPACK FOOTER //
// ./src/Backend/sparePartsCatalogue/sbom/MasterSparepart/store.js